import React from "react";
import PropTypes from "prop-types";
import posterFallback from "../../images/morph-thumb.jpg";

// 🔒 Hardcoded media paths (update these if your file names change)
const VIDEO_DESKTOP_SRC = "/video/morph-collective-new.mp4";
const VIDEO_MOBILE_SRC  = "/video/morph-collective-new.mp4"; // use a different file if you have one
const POSTER_SRC        = posterFallback;

const JoinVideo = (props) => {
  const data = props.data || {};

  // Text/content from WP
  const labeltext   = data.labeltext || "";            // e.g. "Join"
  const title       = data.title || "";                // e.g. "The fastest growing DAO..."
  const description = data.description ?? data.text ?? "";
  const ctaUrl      = data?.cta?.url || data.ctaUrl || "";
  const ctaText     = data?.cta?.title || data.ctaText || "";

  // Visuals (safe fallbacks so badge renders even if WP empty)
  const bgClass     = data.bgClass || "bg-yellow";
  const labelNumber = data.labelNumber ?? "06";

  // ✅ Hardcoded video/poster (no WP fallback)
  const videoUrlDesktop = VIDEO_DESKTOP_SRC;
  const videoUrlMobile  = VIDEO_MOBILE_SRC;
  const posterUrl       = POSTER_SRC;

  const Video = ({ src }) => (
    <div className="video-wrapper">
      <video
        controls
        muted
        preload="metadata"
        autoPlay
        playsInline
        loop
        poster={posterUrl}
      >
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );

  return (
    <section className="pt-lg-16 pb-lg-16 pb-11 pt-11">
      <div className="container">
        <div className="row">
          {/* Text + Mobile video */}
          <div className="col-lg-5 col-md-12">
            <div className="feature-card">
              <div className="d-flex mb-6">
                <span className={`zg-label ${bgClass} text-black me-2`}>{labelNumber}</span>
                {labeltext ? (
                  <span className={`zg-label ${bgClass} text-black`}>{labeltext}</span>
                ) : null}
              </div>

              {title ? <h2 className="h3 mb-6 rm-title">{title}</h2> : null}

              {/* Mobile video */}
              <div className="col-12 col-md-12 text-center text-lg-start mb-6 hidden-desktop vdo-border m-0">
                <Video src={videoUrlMobile} />
              </div>

              {description ? <p className="mb-6 rm-md-text">{description}</p> : null}

              {ctaUrl && ctaText ? (
                <a
                  href={ctaUrl}
                  className="btn-outline-white btn-lg btn"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {ctaText}
                </a>
              ) : null}
            </div>
          </div>

          {/* Desktop video */}
          <div className="col-lg-6 offset-lg-1 col-md-12 mt-5 hidden-mobile">
            <div className="feature-card mt-5">
              <div className="col-12 col-md-12 text-center text-lg-start vdo-border m-0">
                <Video src={videoUrlDesktop} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

JoinVideo.propTypes = {
  data: PropTypes.shape({
    // text from WP
    labeltext: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.string, // legacy
    // visuals from WP
    bgClass: PropTypes.string, // e.g. "bg-yellow"
    labelNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // CTA (either Link field or separate)
    cta: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
      target: PropTypes.string,
    }),
    ctaUrl: PropTypes.string,
    ctaText: PropTypes.string,
  }),
};

export default JoinVideo;
